import { useTheme } from 'next-themes'
import type { JSX } from 'react'
import { Toaster as SileoToaster } from 'sileo'

/**
 * Contenedor de notificaciones (Sileo). Se monta una vez en `main.tsx`; las
 * notificaciones se disparan con `appToast` de `@/lib/toast`, nunca con `sileo`
 * directo.
 *
 * - **`theme` desde `resolvedTheme`**, no `theme`: `next-themes` puede devolver
 *   `'system'`, y Sileo decide con él su relleno por defecto. El relleno y los
 *   colores reales los fija `globals.css` con tokens de marca (bloque
 *   "Notificaciones — Sileo"); aquí solo se mantiene a Sileo en sincronía con
 *   el interruptor de tema de la app.
 * - **`top-center`**, no `top-right`: a la derecha del header viven la campana,
 *   el selector de tema y el avatar, y una píldora de 350px los tapa mientras
 *   dura. Al centro solo hay espacio libre entre las migas de pan y los
 *   controles. (El comentario original de `main.tsx` ya pedía `top-center`,
 *   pero el wrapper de Sonner lo pisaba con `top-right`.)
 * - **`offset.top` con `env(safe-area-inset-top)`**: `index.html` declara
 *   `viewport-fit=cover`, así que en iPhones con notch (PWA o landscape) la
 *   píldora quedaría bajo la muesca.
 */
export function Toaster(): JSX.Element {
  const { resolvedTheme } = useTheme()

  return (
    <SileoToaster
      position="top-center"
      theme={resolvedTheme === 'dark' ? 'dark' : 'light'}
      offset={{ top: 'env(safe-area-inset-top, 0px)' }}
    />
  )
}
